// extracted by mini-css-extract-plugin
module.exports = {"container":"recovery-form-wrapper_container__3C1Bd","text":"recovery-form-wrapper_text__36IIi","img":"recovery-form-wrapper_img__1U9PT"};